import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ACTIONS from 'redux-lib/actions/actions';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
      '& .MuiTextField-root': {
        width: '25ch',
      },
    },
    select: {
      '& .MuiSelect-icon': {
        color: '#3f88b1'
      }
    }
  }));

function DealName(props) {
    const classes = useStyles();
    const states = useSelector(state => {
      return state.globalStates
    })
    return(
        <div className={ classes.root }>
            <h2 className={`deal-person-name`}>{ states.person_name }</h2>
        </div>
    )
}

export default DealName;